module.exports = __webpack_public_path__ + "img/astro8.4e86ed23.jpg";